const allProjectsLithuanian = [
    {
      title: "Python Žaidimai",
      projects: [
        {
          projectTitle: "Pong",
          projectDetails: "Python",
          projectDescription:
            "Klasikinis 80' žaidims Pong.",
          githubLink: "https://github.com/CaptainCutlet/PongGame",
          imageUrl: "https://img.icons8.com/?size=512&id=8fkW1CkMYnE8&format=png",
        },
        {
          projectTitle: "Gyvatėlė",
          projectDetails: "Python",
          projectDescription:
            "Klasikinis gyvatėlės žaidimas.",
          githubLink: "https://github.com/CaptainCutlet/SnakeGame",
          imageUrl: "https://img.icons8.com/?size=512&id=OwPRfsLEUW71&format=png",
        },
      ],
    },
    {
      title: "Interneto Svetainių Projektai",
      projects: [
        {
          projectTitle: "Nepavykęs NFT Start'upas",
          projectDetails: "React, Next.js, Javascript, Tailwind, Flask (Python), Solidity",
          projectDescription:
            "Buvo bandyta padaryti NFT start'upą, tačiau nepavyko. Nepaisant to, gerai padaryta svetainė išliko.",
          githubLink: "https://github.com/CaptainCutlet/MintMasterAI",
          imageUrl: "https://www.speakeragency.co.uk/media/h4shzgp0/387840464-690x460.jpg",
        },
        {
          projectTitle: "Freelanci'nimo Svetainė",
          projectDetails: "React, Next.js, Javascript, Tailwind",
          projectDescription:
            "Pavyzdinė svetainė kompanijos, kuri teikia svetainių kūrimo paslaugas.",
          githubLink: "https://github.com/CaptainCutlet/Uturex.com",
          imageUrl: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT4BhpFKCJ0_LAl-WhYLzk-84c-uQCkvKNObg&s",
        },
      ],
    },
    {
      title: "Python / Flask svetainės",
      projects: [
        {
          projectTitle: "Darbo Kavinės",
          projectDetails: "Python, Flask, Bootstrap, HTML, CSS",
          projectDescription:
            "Svetainė skirta vertinti ir reklamuoti darbui skirtas kavines.",
          githubLink: "https://github.com/CaptainCutlet/WorkCaffesWebsite",
          imageUrl: "https://img.icons8.com/?size=512&id=RvOh5UtuJeJX&format=png",
        },
        {
          projectTitle: "Mėgstamiausi Filmai",
          projectDetails: "Python, Flask, Bootstrap, HTML, CSS",
          projectDescription:
            "Svetainė skirta sukurti asmeninę labiausiai patikusių filmų kolekciją.",
          githubLink: "https://github.com/CaptainCutlet/FavoriteMovies",
          imageUrl: "https://img.icons8.com/?size=512&id=12844&format=png",
        },
      ],
    },
    {
      title: "Flutter Programėlės",
      projects: [
        {
          projectTitle: "Elektroninės parduotuvės aplikacija",
          projectDetails: "Flutter, Firebase",
          projectDescription:
            "Elektroninės parduotuvės programėlė skirta pirkti ir parduoti norimus daiktus.",
          githubLink: "https://github.com/CaptainCutlet/ShopApp",
          imageUrl: "https://img.icons8.com/?size=512&id=13014&format=png",
        },
        {
          projectTitle: "Kalorijų Skaičiavimo ir Receptų Programa",
          projectDetails: "Flutter, Firebase",
          projectDescription:
            "Ši programa skirta ne tik kurti receptus, bet ir automatiškai sekti per dieną suvartotų kalorijų skaičių esantį aplikacijos receptuose.",
          githubLink: "https://github.com/CaptainCutlet/CalorieTrackerApp",
          imageUrl: "https://img.icons8.com/?size=512&id=12869&format=png",
        },
      ],
    },
    {
      title: "Unity Žaidimai",
      projects: [
        {
          projectTitle: "Bėk ir Šok",
          projectDetails: "Unity, C#",
          projectDescription:
            "90-ųjų metų klasikinis bėgimo ir šokinėjimo per kliūtis žaidimas.",
          githubLink: "https://github.com/CaptainCutlet/RunAndJump",
          imageUrl: "https://img.icons8.com/?size=512&id=33504&format=png",
        },
        {
          projectTitle: "Lėktuvo Skrydis",
          projectDetails: "Unity, C#",
          projectDescription:
            "Lektuvo skrydžio simuliatorius.",
          githubLink: "https://github.com/CaptainCutlet/PlaneFlight",
          imageUrl: "https://img.icons8.com/?size=512&id=15120&format=png",
        },
      ],
    },
  ];

  export default allProjectsLithuanian;